/* Current customer auth: mobile check, PIN login, OTP login, signup, reset PIN.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";
const CryptoJS = require("crypto-js");
import Cookies from "js-cookie";

export default {
  methods: {

    // Add OTP login methods

onlyAllowNumbers(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Prevent non-numeric input
    }
  },
  
// In the sendLoginOTP method, update the state handling
async sendLoginOTP() {
  if (!this.resultsMobile.isValid) return;
  
  try {
    const response = await axios.post(
      this.customer_api_base_url + "customer-forgot-pass",
      {
        mobile_no: this.resultsMobile.formattedNumber,
        countryCode: this.resultsMobile.countryCode,
      }
    );

    if (response.data.sp_code === '200') {
      this.showLoginOTPForm = true;
      this.startResendTimer();
    } 
    else if (response.data.sp_code === '403') { 
      this.snackbar = true;
      this.color = "success";
      this.timeout = 3000;
      this.popup_text = response.data.message;
    }

    // Add this condition for non-existing users
    else if (response.data.sp_code === '102') { 
      this.showSignupForm = true;
      this.showLoginOTPForm = false;  // Hide OTP section
      this.snackbar = true;
      this.color = "success";
      this.timeout = 3000;
      this.popup_text = "No account exists. Create an account";
      this.cof_signup.mobile_number = this.resultsMobile.formattedNumber;
    }
  } catch (error) {
    this.showError('Failed to send OTP');
  }
},

    async verifyLoginOTP() {
      const otp = this.loginOTP.join('');
      
      try {
        const response = await axios.post(
          this.customer_api_base_url + 'verify-login-otp',
          {
            mobile_no: this.resultsMobile.formattedNumber,
            otp:otp,
            countryCode: this.resultsMobile.countryCode,
            orderid:this.$route.query.order_id

          }
        );

        if (response.data.sp_code === '111') {
          this.showLoginOTPForm = false;
          this.resultsMobile = '';
          this.handleSuccessfulLogin(response.data);
        }
      } catch (error) {
        this.showError('Invalid OTP');
      }
    },

    startResendTimer() {
      this.resendTimer = 60;
      this.resendDisabled = true;
      const timer = setInterval(() => {
        if (this.resendTimer <= 0) {
          clearInterval(timer);
          this.resendDisabled = false;
          return;
        }
        this.resendTimer--;
      }, 1000);
    },

    async resendLoginOTP() {
      this.resendDisabled = true;
      await this.sendLoginOTP();
      this.startResendTimer();
    },

    focusNext(index) {
      if (index < 5 && this.loginOTP[index]) {
        this.$refs[`otp-${index+1}`][0].focus();
      }
    },

    focusPrevious(index) {
      if (index > 0 && !this.loginOTP[index]) {
        this.$refs[`otp-${index-1}`][0].focus();
      }
    },

    handleSuccessfulLogin(response) {
      this.customer_name = response.customer_name;
      this.login_div = false;
      this.myaccount = true;
      this.no_login = false;
      this.user_account = true;
      this.saved_card_tab1 = false;
      this.saved_card_list = false;
      
      // Set cookie/token
      Cookies.set('token', response.token, { 
        expires: response.expires_in / 86400 
      });
      
      this.snackbar = true;
      this.color = 'success';
      this.popup_text = 'Login successful';
      // Prefetch cards without switching PROFILE → card form when empty
      this.getSavedCardList({ silent: true });
      this.check_card_holder_login();
    },

    showError(message) {
      this.snackbar = true;
      this.color = 'red';
      this.popup_text = message;
      this.timeout = 3000;
    },

    changeMobileNumber() {
  // Reset all related states
  this.loginOTP = ['', '', '', '', '', ''];
  this.showLoginOTPForm = false;
  this.showSignupForm = false;
  this.showResetPinOtpForm = false;
  this.showResetPinForm = false;
  this.showPinLoginForm = false;
  this.showMobileCheckForm = true;
  this.resendTimer = 0;
  this.resendDisabled = false;
  this.cof_signup.fullname = '';
  this.cof_signup.pin = '';
  this.cof_signup.pin_confirm = '';
  this.loginPin = '';
  this.resetPinOtp = '';
  this.newPin = '';
  this.newPinConfirm = '';
  this.loginItem.login_mobile_number = '';
  this.resultsMobile = {};
  
  // Clear existing timers
  if (this.resendTimerInterval) {
    clearInterval(this.resendTimerInterval);
  }
},

    // Step 1: check whether the entered mobile number already has an account.
    // Existing -> show PIN login. New -> show signup (Full Name + PIN).
    checkExistingUser() {
      if (!this.resultsMobile || !this.resultsMobile.isValid) {
        this.showError('Please enter a valid mobile number');
        return;
      }
      const token = this.$route.query.token;
      axios
        .post(
          this.base_url + 'customer/phone-number-check',
          { mobile_no: this.resultsMobile.formattedNumber },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then((response) => {
          const data = response.data;
          if (data.sp_code == '200') {
            // Existing user -> PIN login
            this.showMobileCheckForm = false;
            this.showSignupForm = false;
            this.showPinLoginForm = true;
            this.loginPin = '';
          } else {
            // New user -> signup with mandatory PIN
            this.showMobileCheckForm = false;
            this.showPinLoginForm = false;
            this.showSignupForm = true;
            this.cof_signup.mobile_number = this.resultsMobile.formattedNumber;
          }
        })
        .catch(() => {
          this.showError('Something went wrong. Please try again');
        });
    },

    // Return to the first step (mobile number entry).
    backToMobileCheck() {
      this.showMobileCheckForm = true;
      this.showPinLoginForm = false;
      this.showSignupForm = false;
      this.showLoginOTPForm = false;
      this.showResetPinOtpForm = false;
      this.showResetPinForm = false;
      this.loginPin = '';
      this.loginOTP = ['', '', '', '', '', ''];
      this.resetPinOtp = '';
      this.newPin = '';
      this.newPinConfirm = '';
      this.cof_signup.pin = '';
      this.cof_signup.pin_confirm = '';
      if (this.resendTimerInterval) {
        clearInterval(this.resendTimerInterval);
      }
    },

    // Login with mobile number + 4-digit PIN (primary login method).
    handlePinLogin() {
      if (!this.resultsMobile || !this.resultsMobile.isValid) {
        this.showError('Please enter a valid mobile number');
        return;
      }
      if (!this.loginPin || this.loginPin.length !== 4) {
        this.showError('Please enter your 4-digit PIN');
        return;
      }
      const token = this.$route.query.token;
      axios
        .post(
          this.customer_api_base_url + 'customer-pin-login',
          {
            mobile_no: this.resultsMobile.formattedNumber,
            pin: this.loginPin,
            countryCode: this.resultsMobile.countryCode,
            orderid: this.$route.query.order_id,
          },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then((response) => {
          const data = response.data;
          if (data.sp_code === '200' && data.is_active == 1) {
            this.loginPin = '';
            this.handleSuccessfulLogin({
              customer_name: data.customer_name,
              token: data.token || data.access_token,
              expires_in: data.expires_in,
            });
          } else if (data.sp_code === '102') {
            // Not registered -> route to signup
            this.showError('No account found. Please sign up');
            this.showMobileCheckForm = false;
            this.showPinLoginForm = false;
            this.showSignupForm = true;
            this.cof_signup.mobile_number = this.resultsMobile.formattedNumber;
          } else if (data.sp_code === '209') {
            this.showError('No PIN set. Please reset your PIN');
          } else if (data.sp_code === '110') {
            this.showError('Account not verified. Sending OTP...');
            this.useOtpLogin();
            this.sendLoginOTP();
          } else {
            this.showError(data.message || 'Incorrect PIN');
          }
        })
        .catch(() => {
          this.showError('Login failed. Please try again');
        });
    },

    // Switch from PIN login to the OTP login method.
    useOtpLogin() {
      this.showMobileCheckForm = false;
      this.showPinLoginForm = false;
      this.showSignupForm = false;
      this.showResetPinOtpForm = false;
      this.showResetPinForm = false;
      this.showLoginOTPForm = false;
      this.loginPin = '';
    },

    // Return to the PIN login screen and clear transient state.
    backToPinLogin() {
      this.showMobileCheckForm = false;
      this.showPinLoginForm = true;
      this.showSignupForm = false;
      this.showLoginOTPForm = false;
      this.showResetPinOtpForm = false;
      this.showResetPinForm = false;
      this.loginOTP = ['', '', '', '', '', ''];
      this.resetPinOtp = '';
      this.newPin = '';
      this.newPinConfirm = '';
      this.cof_signup.pin = '';
      this.cof_signup.pin_confirm = '';
      if (this.resendTimerInterval) {
        clearInterval(this.resendTimerInterval);
      }
    },

    // Reset PIN step 1: trigger an OTP to the user's mobile number.
    startResetPin() {
      if (!this.resultsMobile || !this.resultsMobile.isValid) {
        this.showError('Please enter a valid mobile number');
        return;
      }
      axios
        .post(this.customer_api_base_url + 'customer-forgot-pass', {
          mobile_no: this.resultsMobile.formattedNumber,
          countryCode: this.resultsMobile.countryCode,
        })
        .then((response) => {
          const data = response.data;
          if (data.sp_code === '200') {
            this.showPinLoginForm = false;
            this.showSignupForm = false;
            this.showLoginOTPForm = false;
            this.showResetPinForm = false;
            this.showResetPinOtpForm = true;
            this.resetPinOtp = '';
            this.startResendTimer();
            this.snackbar = true;
            this.color = 'success';
            this.popup_text = 'OTP sent to reset your PIN';
            this.timeout = 3000;
          } else if (data.sp_code === '102') {
            this.showError('No account found. Please sign up');
            this.showMobileCheckForm = false;
            this.showPinLoginForm = false;
            this.showSignupForm = true;
            this.cof_signup.mobile_number = this.resultsMobile.formattedNumber;
          } else if (data.sp_code === '403') {
            this.showError(data.message);
          } else {
            this.showError(data.message || 'Failed to send OTP');
          }
        })
        .catch(() => {
          this.showError('Failed to send OTP');
        });
    },

    // Reset PIN step 2: move from OTP entry to the set-new-PIN screen.
    continueResetPin() {
      if (!this.resetPinOtp || this.resetPinOtp.length < 4) {
        this.showError('Please enter the OTP');
        return;
      }
      this.showResetPinOtpForm = false;
      this.showResetPinForm = true;
      this.newPin = '';
      this.newPinConfirm = '';
    },

    // Reset PIN step 3: submit the OTP + new PIN to be verified and saved.
    submitResetPin() {
      if (!this.newPin || this.newPin.length !== 4) {
        this.showError('PIN must be 4 digits');
        return;
      }
      if (this.newPin !== this.newPinConfirm) {
        this.showError('PIN and Confirm PIN do not match');
        return;
      }
      const token = this.$route.query.token;
      axios
        .post(
          this.customer_api_base_url + 'customer-reset-pin',
          {
            mobile_no: this.resultsMobile.formattedNumber,
            verify_code: this.resetPinOtp,
            pin: this.newPin,
            pin_confirmation: this.newPinConfirm,
            countryCode: this.resultsMobile.countryCode,
          },
          { headers: { Authorization: 'Bearer ' + token } }
        )
        .then((response) => {
          const data = response.data;
          if (data.sp_code === '200') {
            this.snackbar = true;
            this.color = 'success';
            this.popup_text = 'PIN reset successful. Please login';
            this.timeout = 3000;
            this.loginPin = '';
            this.backToPinLogin();
          } else if (data.sp_code === '101') {
            this.showError('Entered OTP does not match');
            this.showResetPinForm = false;
            this.showResetPinOtpForm = true;
          } else if (data.sp_code === '103') {
            this.showError('OTP expired. Please resend');
            this.showResetPinForm = false;
            this.showResetPinOtpForm = true;
          } else {
            this.showError(data.message || 'PIN reset failed');
          }
        })
        .catch(() => {
          this.showError('PIN reset failed. Please try again');
        });
    },

    CheckLoginFunction() {
      var customer_token = this.getCookie("token");
      if (customer_token !== "") {
        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-token-check",
          headers: {
            Authorization: "Bearer " + customer_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.loginBool = 1;
            } else {
              this.loginBool = 0;
            }
          })
          .catch((error) => {
            this.loginBool = 0;
          });
      } else {
        this.loginBool = 0;
      }
    },

    // COF start

    CheckLogin() {
      if (this.checkbox == true) {
        if (
          this.editedItem.card_number !== "" &&
          this.editedItem.mm_yy !== "" &&
          this.editedItem.cvc_cvv !== "" &&
          this.editedItem.card_holder_name !== ""
        ) {
          if (this.loginBool == 1) {
            this.showCreateAccountForm = false;
            this.showCOFRegisterOTPForm = false;
            this.isCOFLoginFormEnable = false;
          }

          if (this.loginBool == 0) {
            this.isFormValid = false;
            var token = this.$route.query.token;
            var mobile_no = this.customer_trxn_mobile_number;
            const options = {
              method: "POST",
              url: this.base_url + "customer/phone-number-check",
              headers: { Authorization: "Bearer " + token },
              data: { mobile_no },
            };
            axios
              .request(options)
              .then((response) => {
                this.isFormValid = false;
                this.is_cof_form_enable = false;
                this.is_cof_form_enable_terms = false;
                this.is_cof_form_enable_btn = false;
                this.is_mask_card_enable = true;

                var non_mask_card_number = this.editedItem.card_number;
                var first_four_digits = non_mask_card_number.slice(0, 4);
                var last_four_digit = non_mask_card_number.slice(-4);
                this.mask_card_number =
                  first_four_digits +
                  " **** " +
                  " ****" +
                  " " +
                  last_four_digit;

                // Customer exists
                if (response.data.sp_code == "200") {
                  this.isCOFLoginFormEnable = true;

                  if (this.customer_trxn_mobile_number.length == 11) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number;
                  } else if (this.customer_trxn_mobile_number.length == 13) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number.slice(
                      2
                    );
                  } else if (this.customer_trxn_mobile_number.length == 14) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number.slice(
                      3
                    );
                  } else {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number;
                  }
                }

                // Customer does not exists
                else {
                  this.cof_signup.mobile_number = this.customer_trxn_mobile_number;
                  this.cof_signup.fullname = this.editedItem.card_holder_name;
                  this.showCreateAccountForm = true;
                  this.showCOFRegisterOTPForm = false;
                  this.isCOFLoginFormEnable = false;
                }
              })
              .catch((error) => {
                console.log(error);
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = "Something went wrong...";
              });
          }
        } else {
          this.snackbar = true;
          this.color = "success";
          this.timeout = 2000;
          this.popup_text = "Fill up the card information first";
          this.showCreateAccountForm = false;
          this.showCOFRegisterOTPForm = false;
          this.isCOFLoginFormEnable = false;

          var input_element = document.getElementById(
            "check_login_checkbox_id"
          );
          input_element.click();
        }
      } else {
        this.showCreateAccountForm = false;
        this.showCOFRegisterOTPForm = false;
        this.is_cof_form_enable = true;
        this.is_cof_form_enable_terms = true;
        this.is_cof_form_enable_btn = true;
        this.is_mask_card_enable = false;
        this.isCOFLoginFormEnable = false;
        this.AccountActiveDeactiveDiv = false;
      }
    },

    COFregister() {
      if (this.resultsMobile["isValid"]) {
        if (      
          this.cof_signup.fullname !== ""
        ) {
          // PIN is mandatory on COF signup
          if (!this.cof_signup.pin || this.cof_signup.pin.length !== 4) {
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "Please set a 4-digit PIN";
            this.isFormValid = false;
            this.isCheckLoginEnable = true;
            return;
          }
          if (this.cof_signup.pin !== this.cof_signup.pin_confirm) {
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "PIN and Confirm PIN do not match";
            this.isFormValid = false;
            this.isCheckLoginEnable = true;
            return;
          }

          var token = this.$route.query.token;

          var countryCode = this.resultsMobile["countryCode"];
          var formattedNumber = this.resultsMobile["formattedNumber"];

          var email = this.cof_signup.email_address;
          var name = this.cof_signup.fullname;
          var mobile_no = formattedNumber;
          var pin = this.cof_signup.pin;
          var pin_confirmation = this.cof_signup.pin_confirm;

          this.cof_user_reg_mobile = formattedNumber;

          const options = {
            method: "POST",
            url: this.customer_api_base_url + "customer-sign-up",
            headers: {
              Authorization: "Bearer " + token,
            },
            data: {
              name,
              email,
              mobile_no,
              countryCode,
              pin,
              pin_confirmation,
            },
          };
          axios
            .request(options)
            .then((response) => {
              if (response.data.sp_code == "200") {
                this.showCreateAccountForm = false;
                this.showCOFRegisterOTPForm = true;
                this.cof_user_reg_mobile = formattedNumber;
                this.cof_auto_login_country_code = countryCode;
                this.isFormValid = false;

                this.is_cof_form_enable_btn = false;

                this.is_cof_form_enable_btn2 = true;

                this.isCheckLoginEnable = false;
                this.dispaly_time_otp = true;
                this.display_resend_otp_text = false;
                this.showRemaining(3);
              } else if (response.data.sp_code === '201') {
                  // If mobile exists, switch to login OTP flow
                  this.showCreateAccountForm = false;
                  this.showCOFRegisterOTPForm = false;
                  this.isCOFLoginFormEnable = true;
                  this.customer_trxn_mobile_number = mobile_no;

                  if (this.customer_trxn_mobile_number.length == 11) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number;
                  } else if (this.customer_trxn_mobile_number.length == 13) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number.slice(
                      2
                    );
                  } else if (this.customer_trxn_mobile_number.length == 14) {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number.slice(
                      3
                    );
                  } else {
                    this.cof_login_mobile_number = this.customer_trxn_mobile_number;
                  }
                }else {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = response.data.message;
                this.isFormValid = false;
                this.isCheckLoginEnable = true;
              }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = "Something went wrong...";
              this.isFormValid = false;
              this.isCheckLoginEnable = true;
            });
        } else {
          this.snackbar = true;
          this.color = "red";
          this.timeout = 2000;
          this.popup_text = "Please Fill Up required fields";
          this.isFormValid = false;
          this.isCheckLoginEnable = true;
        }
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Mobile Number is not valid";
        this.isFormValid = false;
        this.isCheckLoginEnable = true;
      }

      this.isFormValid = false;
    },

    // Add this in methods section
    async handleLoginSignup() {
      try {
        if (!this.resultsMobile.isValid) {
          this.showError('Invalid mobile number format');
          return;
        }

        if (!this.cof_signup.fullname || this.cof_signup.fullname.trim().length < 3) {
          this.showError('Please enter your full name');
          return;
        }

        // PIN is mandatory on signup
        if (!this.cof_signup.pin || this.cof_signup.pin.length !== 4) {
          this.showError('Please set a 4-digit PIN');
          return;
        }

        if (this.cof_signup.pin !== this.cof_signup.pin_confirm) {
          this.showError('PIN and Confirm PIN do not match');
          return;
        }

        const response = await axios.post(
          this.customer_api_base_url + "customer-sign-up",
          {
            name: this.cof_signup.fullname,
            mobile_no: this.resultsMobile.formattedNumber,
            countryCode: this.resultsMobile.countryCode,
            pin: this.cof_signup.pin,
            pin_confirmation: this.cof_signup.pin_confirm
          },
          { 
            headers: { 
              Authorization: "Bearer " + this.$route.query.token 
            } 
          }
        );

        if (response.data.sp_code === '200') {
          // Transition directly to OTP verification
          this.showSignupForm = false;
          this.showLoginOTPForm = true;
          this.loginItem.login_mobile_number = this.resultsMobile.formattedNumber;
          
          // Start OTP timer
          this.startResendTimer();
          
          this.snackbar = true;
          this.color = "success";
          this.popup_text = "OTP sent to your mobile number";
          this.timeout = 3000;

        } else if (response.data.sp_code === '201') {
          this.showError('Mobile number already registered');
        } else if (response.data.sp_code === '203') {
          this.showError('Invalid phone number format');
        } else if (response.data.sp_code === '204') {
          this.showError('Registration failed. Please try again.');
        } else {
          this.showError('Unknown error occurred');
        }

      } catch (error) {
        if (error.response && error.response.data) {
          const apiError = error.response.data;
          this.showError(apiError.message || 'Registration failed');
        } else {
          this.showError('Network error. Please check your connection.');
        }
      }
    },

    COFSubmitOTP() {
      this.isFormValid = false;
      this.isCheckLoginEnable = false;

      var customer_entered_otp =
        this.cof_reg_otp_confirm.one +
        this.cof_reg_otp_confirm.two +
        this.cof_reg_otp_confirm.three +
        this.cof_reg_otp_confirm.four +
        this.cof_reg_otp_confirm.five +
        this.cof_reg_otp_confirm.six;

      if (customer_entered_otp.length == 6 && this.cof_user_reg_mobile !== "") {
        var token = this.$route.query.token;
        var verify_code = customer_entered_otp;
        var mobile_no = this.cof_user_reg_mobile;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "verify-login-otp",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            otp:verify_code,
            mobile_no,
            orderid: this.$route.query.order_id,
            countryCode: this.countryCode
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
            //  this.COFCustomerAutoLogin(mobile_no);
              this.is_cof_form_enable_btn2 = false;

              this.customer_name = response.data.customer_name;
              this.login_div = false;
              this.myaccount = true;
              this.no_login = false;
              this.loginBool = 1;
              this.user_account = true;
              this.saved_card_tab1 = false;
              this.saved_card_list = false;

              this.showCreateAccountForm = false;
              this.showCOFRegisterOTPForm = false;
              this.isCOFLoginFormEnable = false;
              

              // this.isFormValid = true;
              // this.is_cof_form_enable = true;
              // this.is_cof_form_enable_terms = true;
              // this.is_cof_form_enable_btn = true;
              // this.is_mask_card_enable = false;

              this.isFormValid = false;
              this.is_cof_form_enable = false;
              this.is_cof_form_enable_terms = false;
              this.is_cof_form_enable_btn = true;
              this.is_mask_card_enable = true;
              this.isCheckLoginEnable = false;
              this.hideshowpaynow = true;

              //Set cookie information
              var cookie_name = "token";
              var cookie_value = response.data.token;
              var exipry_from_token = response.data.expires_in;
              let date = new Date();
              date.setTime(date.getTime() + exipry_from_token * 1000);
              let cookie_time = "expires=" + date.toUTCString();
              document.cookie =
                cookie_name + "=" + cookie_value + "; " + cookie_time + "; ";
                // Set cookie/token
              Cookies.set('token', response.data.token, { 
                expires: response.data.expires_in / 86400 
              });
              // Prefetch cards without switching PROFILE → card form when empty
              this.getSavedCardList({ silent: true });

            } else if (response.data.sp_code == "101") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "OTP does not matched";
            } else if (response.data.sp_code == "103") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "Something Went Wrong";
          });
      }

      if (customer_entered_otp.length < 5 && this.cof_user_reg_mobile === "") {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Please fill up OTP fields";
      }
    },

    COFResendOTP() {
      var token = this.$route.query.token;
      var mobile_no = this.cof_user_reg_mobile;
      const options = {
        method: "POST",
        url: this.customer_api_base_url + "customer-resend-code",
        headers: {
          Authorization: "Bearer " + token,
        },
        data: {
          mobile_no,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.sp_code == "200") {
            this.snackbar = true;
            this.color = "success";
            this.timeout = 4000;
            this.popup_text = "A New OTP sent to " + this.cof_user_reg_mobile;

            this.dispaly_time_otp = true;
            this.display_resend_otp_text = false;
            this.showRemaining(3);
          } else {
            this.snackbar = true;
            this.color = "red";
            this.timeout = 4000;
            this.popup_text = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    COFCustomerAutoLogin(mobile_no) {
      this.isFormValid = false;
      if (mobile_no !== "") {
        var countryCode = this.cof_auto_login_country_code;
        var token = this.$route.query.token;
        var password_real = this.cof_pin_number;

        var CryptoJSAesJson = {
          stringify: function(cipherParams) {
            var j = {
              ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
            };
            if (cipherParams.iv) j.iv = cipherParams.iv.toString();
            if (cipherParams.salt) j.s = cipherParams.salt.toString();
            return JSON.stringify(j);
          },
        };

        var key = this.$route.query.order_id;
        var orderid = this.$route.query.order_id;
        var password = CryptoJS.AES.encrypt(
          JSON.stringify(password_real),
          key,
          { format: CryptoJSAesJson }
        ).toString();

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-login",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            mobile_no,
            password,
            countryCode,
            orderid,
          },
        };

        axios
          .request(options)
          .then((response) => {
            //When the user is active and successful login
            if (
              response.data.is_active == 1 &&
              response.data.sp_code == "200"
            ) {
              this.is_cof_form_enable_btn2 = false;

              this.customer_name = response.data.customer_name;
              this.login_div = false;
              this.myaccount = true;
              this.no_login = false;
              this.loginBool = 1;

              this.showCreateAccountForm = false;
              this.showCOFRegisterOTPForm = false;
              this.isCOFLoginFormEnable = false;

              // this.isFormValid = true;
              // this.is_cof_form_enable = true;
              // this.is_cof_form_enable_terms = true;
              // this.is_cof_form_enable_btn = true;
              // this.is_mask_card_enable = false;

              this.isFormValid = false;
              this.is_cof_form_enable = false;
              this.is_cof_form_enable_terms = false;
              this.is_cof_form_enable_btn = true;
              this.is_mask_card_enable = true;
              this.isCheckLoginEnable = false;

              //Set cookie information
              var cookie_name = "token";
              var cookie_value = response.data.token;
              var exipry_from_token = response.data.expires_in;
              let date = new Date();
              date.setTime(date.getTime() + exipry_from_token * 1000);
              let cookie_time = "expires=" + date.toUTCString();
              document.cookie =
                cookie_name + "=" + cookie_value + "; " + cookie_time + "; ";
            }

            //Password not matched
            else if (response.data.sp_code == "1064") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 2000;
              this.popup_text = response.data.message;
            }

            //No such account exist,Wrong Mobile number
            else if (response.data.sp_code == "102") {
              this.snackbar = true;
              this.color = "error";
              this.timeout = 6000;
              this.popup_text = response.data.message;
            }

            //Account is not active popup account active modal
            else if (
              response.data.is_active == 0 &&
              response.data.sp_code == "200"
            ) {
              this.showCreateAccountForm = false;
              this.isCOFLoginFormEnable = false;
              this.showCOFRegisterOTPForm = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
            this.color = "red";
            this.popup_text = "Something went wrong...";
          });
      }
    },

    COFLoginAction() {
      if (this.resultsMobile["isValid"]) {
   
          var countryCode = this.resultsMobile["countryCode"];
          var formattedNumber = this.resultsMobile["formattedNumber"];
          var token = this.$route.query.token;
          var mobile_no = formattedNumber;
          var password_real = this.cof_login_pin;

          var CryptoJSAesJson = {
            stringify: function(cipherParams) {
              var j = {
                ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
              };
              if (cipherParams.iv) j.iv = cipherParams.iv.toString();
              if (cipherParams.salt) j.s = cipherParams.salt.toString();
              return JSON.stringify(j);
            },
          };

          var key = this.$route.query.order_id;
          var orderid = this.$route.query.order_id;
          var password = CryptoJS.AES.encrypt(
            JSON.stringify(password_real),
            key,
            { format: CryptoJSAesJson }
          ).toString();

          const options = {
            method: "POST",
            url: this.customer_api_base_url + "customer-forgot-pass",
            headers: {
              Authorization: "Bearer " + token,
            },
            data: {
              mobile_no,
              countryCode,
            },
          };

          axios
            .request(options)
            .then((response) => {
              //When the user is active and successful login
              if (response.data.sp_code == "200") {

                this.showCreateAccountForm = false;
                this.showCOFRegisterOTPForm = true;
                this.isCOFLoginFormEnable = false;
                this.cof_user_reg_mobile = formattedNumber;
                this.cof_pin_number = password;
                this.cof_auto_login_country_code = countryCode;
                this.isFormValid = false;

                this.is_cof_form_enable_btn = false;

                this.is_cof_form_enable_btn2 = true;

                this.isCheckLoginEnable = false;
                this.dispaly_time_otp = true;
                this.display_resend_otp_text = false;
                this.showRemaining(3);
              } else {
                this.snackbar = true;
                this.color = "red";
                this.timeout = 2000;
                this.popup_text = response.data.message;
                this.isFormValid = false;
                this.isCheckLoginEnable = true;
              }

              // //Password not matched
              // else if (response.data.sp_code == "1064") {
              //   this.snackbar = true;
              //   this.color = "error";
              //   this.timeout = 2000;
              //   this.popup_text = response.data.message;
              // }

              // //No such account exist with this Mobile number
              // //Redirect to create an account
              // else if (response.data.sp_code == "102") {
              //   this.cof_signup.mobile_number = mobile_no;
              //   this.cof_signup.fullname = this.editedItem.card_holder_name;
              //   this.showCreateAccountForm = true;
              //   this.showCOFRegisterOTPForm = false;
              //   this.isCOFLoginFormEnable = false;
              //   this.AccountActiveDeactiveDiv = false;
              // }

              // //Account is not active popup account active modal
              // else if (
              //   response.data.is_active == 0 &&
              //   response.data.sp_code == "200"
              // ) {
              //   this.showCreateAccountForm = false;
              //   this.showCOFRegisterOTPForm = false;
              //   this.COFsendActiveOTPAuto(formattedNumber);
              // }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar = true;
              this.color = "red";
              this.popup_text = "Something went wrong...";
            });
      
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Mobile Number is not valid";
      }
    },

    CheckMobileExistsOrNot() {
      if (this.resultsMobile["isValid"]) {
        var forward_mobile_number = this.resultsMobile["phoneNumber"];
        var formattedNumber = this.resultsMobile["formattedNumber"];
        var token = this.$route.query.token;
        var mobile_no = formattedNumber;

        const options = {
          method: "POST",
          url: this.base_url + "customer/phone-number-check",
          headers: { Authorization: "Bearer " + token },
          data: { mobile_no },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "404") {
              this.snackbar = true;
              this.color = "success";
              this.timeout = 3000;
              this.popup_text = "No account exists.Create an account";

              this.cof_signup.mobile_number = forward_mobile_number;
              this.cof_signup.fullname = this.editedItem.card_holder_name;
              this.showCreateAccountForm = true;
              this.showCOFRegisterOTPForm = false;
              this.isCOFLoginFormEnable = false;
            }

            if (response.data.sp_code == "200") {
              this.isCOFLoginFormEnable = true;
              this.showCreateAccountForm = false;
              this.showCOFRegisterOTPForm = false;
              //this.cof_login_mobile_number = this.customer_trxn_mobile_number;
              this.cof_login_mobile_number = forward_mobile_number;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "Something went wrong...";
          });
      }

      // else{
      //   this.snackbar = true;
      //   this.color = "red";
      //   this.timeout = 2000;
      //   this.popup_text = "Mobile Number is not valid";
      // }
    },

    COFsendActiveOTPAuto(formattedNumber) {
      var mobile_no = formattedNumber;
      var token_check = this.$route.query.token;

      const options = {
        method: "POST",
        url: this.customer_api_base_url + "customer-resend-code",
        headers: {
          Authorization: "Bearer " + token_check,
        },
        data: {
          mobile_no,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.sp_code == "200") {
            this.cof_active_account_mobile = formattedNumber;
            this.isCOFLoginFormEnable = false;
            this.AccountActiveDeactiveDiv = true;
          } else {
            this.isCOFLoginFormEnable = true;
            this.snackbar = true;
            this.color = "red";
            this.timeout = 3000;
            this.popup_text = response.data.message;
          }
        })
        .catch((error) => {
          this.isCOFLoginFormEnable = true;
          console.log(error);
        });
    },

    COFActiveAccountOTP() {
      if (this.cof_active_account_otp.length == 6) {
        var token = this.$route.query.token;
        var verify_code = this.cof_active_account_otp;
        var mobile_no = this.cof_active_account_mobile;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            verify_code,
            mobile_no,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              this.isCOFLoginFormEnable = true;
              this.AccountActiveDeactiveDiv = false;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
            this.color = "red";
            this.timeout = 2000;
            this.popup_text = "Something Went Wrong";
          });
      }
    },

    onUpdate(payload) {
      this.resultsMobile = payload;
    },

    ActiveAccountResendOtp() {
      var token = this.$route.query.token;
      var mobile_no = this.active_account_mobile;
      const options = {
        method: "POST",
        url: this.customer_api_base_url + "customer-resend-code",
        headers: {
          Authorization: "Bearer " + token,
        },
        data: {
          mobile_no,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.sp_code == "200") {
            this.snackbar = true;
            this.color = "success";
            this.timeout = 7000;
            this.popup_text = "A new OTP sent to " + this.active_account_mobile;
            this.dispaly_time_otp = true;
            this.display_resend_otp_text = false;
            this.showRemaining(3);
          } else {
            this.snackbar = true;
            this.color = "red";
            this.popup_text = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    ForgotPasswordSendOTP() {
      //let isValid = this.$refs.form2.validate();
      let isValid = this.resultsMobile["isValid"];

      if (isValid) {
        var countryCode = this.resultsMobile["countryCode"];
        var formattedNumber = this.resultsMobile["formattedNumber"];

        this.forgot_password_mobile = formattedNumber;
        var mobile_no = formattedNumber;
        var token_check = this.$route.query.token;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-forgot-pass",
          headers: {
            Authorization: "Bearer " + token_check,
          },
          data: {
            mobile_no,
            countryCode,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.forgot_password_modal = false;
              this.forgot_password_otp_modal = true;
              var inputed_mobile = formattedNumber;
              this.otp_send_text_msg = inputed_mobile;
              this.forgot_password_mobile = inputed_mobile;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.popup_text = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.snackbar = true;
        this.color = "red";
        this.timeout = 2000;
        this.popup_text = "Mobile number is not valid";
      }
    },

    ForgotPasswordSubmitOTP() {
      let isValid = this.$refs.form_otp.validate();
      if (isValid) {
        var token = this.$route.query.token;
        var verify_code = this.forgot_password_otp;
        //var mobile_no = this.forgot_password_mobile;
        var mobile_no = this.otp_send_text_msg;

        const options = {
          method: "POST",
          url: this.customer_api_base_url + "customer-verify-account",
          headers: {
            Authorization: "Bearer " + token,
          },
          data: {
            verify_code,
            mobile_no,
          },
        };

        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "111") {
              this.forgot_password_otp_modal = false;
              this.forgot_password_modal = false;
              this.new_password_modal = true;
              this.reset_password_mobile = mobile_no;
            } else if (response.data.sp_code == "101") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 3000;
              this.popup_text = "OTP does not matched";
              this.reset_password_mobile = mobile_no;
            } else if (response.data.sp_code == "103") {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.reset_password_mobile = mobile_no;
            } else {
              this.snackbar = true;
              this.color = "red";
              this.timeout = 2000;
              this.popup_text = response.data.message;
              this.reset_password_mobile = mobile_no;
            }
          })
          .catch((error) => {
            console.log(error);
            this.reset_password_mobile = mobile_no;
          });
      }
    },
  },
};
